import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'principalBalance',
    label: 'Principal Balance',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'fundingFee',
    label: 'Funding Fee',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'escrowBalance',
    label: 'Escrow Balance',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'firstPayment',
    label: 'First Payment',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'principalPurchased',
    label: 'Principal Purchased',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'taxFee',
    label: 'Tax Fee',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'interest',
    label: 'Interest',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'firstDueToInvestor',
    label: 'First Due To Investor',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'discount',
    label: 'Discount/Premium',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'investorWireAmount',
    label: 'Investor Wire Amount',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const accountingInformationForm = {
  name: FormNames.POST_CLOSING,
  label: 'Accounting Information',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
